import { useState } from "react";
import { Paper, Group, Title, Text, UnstyledButton, Collapse, Divider, Stack } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import type { TransitInfo } from "@/api/types";
import { TransitSummary } from "./TransitSummary";
import { TransitDetails } from "./TransitDetails";

interface TransitTimelineProps {
  transitInfo: TransitInfo;
  officeAddress?: string;
}

export function TransitTimeline({ transitInfo, officeAddress }: TransitTimelineProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const hasLegDetails = transitInfo.legs && transitInfo.legs.length > 0;

  return (
    <Paper p="md" radius="md" withBorder style={{ borderColor: "#0f3460" }}>
      <Group justify="space-between" mb="md">
        <Title order={4}>Transit to Office</Title>
        {hasLegDetails && (
          <UnstyledButton onClick={() => setIsExpanded(!isExpanded)}>
            <IconChevronDown
              size={20}
              color="#888888"
              style={{
                transform: isExpanded ? "rotate(180deg)" : "rotate(0)",
                transition: "transform 200ms",
              }}
            />
          </UnstyledButton>
        )}
      </Group>

      <Collapse expanded={isExpanded && hasLegDetails}>
        <TransitDetails transitInfo={transitInfo} officeAddress={officeAddress} />
      </Collapse>

      {!isExpanded && (
        <Stack gap="sm">
          <TransitSummary transitInfo={transitInfo} />
          {officeAddress && (
            <>
              <Divider color="#0f3460" />
              <Text size="sm" c="dimmed">
                To: {officeAddress}
              </Text>
            </>
          )}
        </Stack>
      )}
    </Paper>
  );
}
